import { TEMPLATE_NAMES } from '@/cms/constants/template-names'
import { useCMSPageField } from '@/cms/fields'
import { DestinationAccoLister } from '@/scopes/destinations/components/AccoLister/DestinationAccoLister'
import DestinationInformation from '@/scopes/destinations/components/DestinationInformation/DestinationInformation'
import { Excursions } from '@/scopes/destinations/components/Excursions/Excursions'
import FlightInformation from '@/scopes/destinations/components/FlightInformation'
import LinkedAccommodations from '@/scopes/destinations/components/LinkedAccommodations/LinkedAccommodations'
import OtherRegions from '@/scopes/destinations/components/OtherRegions'
import PracticalInformation from '@/scopes/destinations/components/PracticalInformation'
import { SearchButton } from '@/scopes/destinations/components/SearchButton/SearchButton'
import { Video } from '@/scopes/destinations/components/Video'
import WeatherTable from '@/scopes/destinations/components/WeatherTable/WeatherTable'
import { Tips } from '../components/Tips/Tips'

export default function ElizaContent() {
  const template = useCMSPageField('template')
  return (
    <>
      <DestinationInformation />
      <Video />
      <SearchButton />
      <DestinationAccoLister />
      <FlightInformation />
      <PracticalInformation />
      {template !== TEMPLATE_NAMES.CountryPage && <WeatherTable />}
      <Excursions />
      <Tips />
      <OtherRegions />
      <SearchButton hiddenOnMobile />
      <LinkedAccommodations />
    </>
  )
}
